import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectUI from '../../../widgets/form/InputSelectUI'
import InputReadOnlyUI from '../../../widgets/form/InputReadOnlyUI'

const TxnDownloadModalUI = ({context, successMsg, errorList, setErrorList,
    // modes
    downloadMode, submitted, bankAccountNumber,
    // event handlers
    onSubmit, onCancelClick,
    //
    period, onPeriodChange, periodError, periodList,
    year, onYearChange, yearError, yearList,
    format, onFormatChange, formatError, formatList
  }) =>
  <ModalFormUI
    context={context}
    titleLabel={bankAccountNumber}
    buttonLabel='Download'
    cancelLabel='Cancel'
    isOpen={downloadMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectUI name='year' value={year} required={true}
      label='Year' optionList={yearList}
      onChange={onYearChange} error={yearError}
    />
    <InputSelectUI name='period' value={period} required={true}
      label='Period' optionList={periodList}
      onChange={onPeriodChange} error={periodError}
    />
    <InputSelectUI name='format' value={format} required={true}
    label='Format' optionList={formatList}
    onChange={onFormatChange} error={formatError}/>
  </ModalFormUI>

export default TxnDownloadModalUI
